// Ids ARIA de las pestañas segmentadas: `<prefijo>-tab-<valor>` y
// `<prefijo>-panel-<valor>` enlazan cada pestaña con su panel (SegTabs).

export const segTabId = (prefix: string, value: string): string => `${prefix}-tab-${value}`;
export const segPanelId = (prefix: string, value: string): string => `${prefix}-panel-${value}`;
